// extracted by mini-css-extract-plugin
module.exports = {"thecomp":"EU10_thecomp__JaHTI"};